import Bugsnag from "@bugsnag/js";
import {
  IChangeMsisdnOrchestrator,
  IChangeSimEsimOrchestrator,
  IFSecureOrchestrator,
  IFsecureReactivationOrchestrator,
  IMobileOrchestrator,
  IMobileReactivationOrchestrator,
  ITvOrchestrator,
} from "@nju/data-access-portal-orchestrator";
import { client } from "@nju/http-client";
import { ok } from "@nju/result";
import { cutPhoneNumberPrefix } from "@nju/utils";
import { IFetchMemberResult } from "./types";
import { serverResponse } from "./validators";

interface IFetchMemberProps {
  userId: string;
}

export async function fetchMember({
  userId,
}: IFetchMemberProps): Promise<IFetchMemberResult> {
  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/users/${userId}/orchestrators`,
    {
      validator: serverResponse,
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
    },
  );

  if (result.isError) {
    Bugsnag.notify(result.err);

    return result;
  }

  const mobile = result.value.find(({ type }) => {
    return type === "NJU_MOBILE_ONBOARDING";
  }) as IMobileOrchestrator | undefined;

  const fsecure = result.value.find(({ type }) => {
    return type === "NJU_FSECURE_ONBOARDING";
  }) as IFSecureOrchestrator | undefined;

  const fsecureReactivation = result.value.find(({ type }) => {
    return type === "NJU_FSECURE_REACTIVATION";
  }) as IFsecureReactivationOrchestrator | undefined;

  const mobileReactivation = result.value.find(({ type }) => {
    return type === "NJU_MOBILE_REACTIVATION";
  }) as IMobileReactivationOrchestrator | undefined;

  const changeMsisdn = result.value.find(({ type }) => {
    return type === "NJU_CHANGE_MSISDN";
  }) as IChangeMsisdnOrchestrator | undefined;

  const changeSimEsim = result.value.find(({ type }) => {
    return type === "NJU_SIM_MANAGEMENT";
  }) as IChangeSimEsimOrchestrator | undefined;

  const tv = result.value.find(({ type }) => {
    return type === "NJU_TV_SERVICE";
  }) as ITvOrchestrator | undefined;

  return ok({
    mobileReactivation: mobileReactivation && {
      ...mobileReactivation,
      isFreeFromActivationFee:
        mobileReactivation.orderSummary?.totalOneTimeOrderPrice === 0,
    },
    mobile: mobile && {
      ...mobile,
      offerId: mobile.offerIds[0],
      contactNumberWithoutCountyCode: cutPhoneNumberPrefix(
        mobile.contactNumber,
      ),
      isFreeFromActivationFee:
        mobile.orderSummary?.totalOneTimeOrderPrice === 0,
    },
    fsecure,
    fsecureReactivation,
    tv,
    changeMsisdn,
    changeSimEsim,
  });
}
